// extracted by mini-css-extract-plugin
module.exports = {"splide__list":"ShowPoster_splide__list__MW3LT","show_poster__link":"ShowPoster_show_poster__link__gzPSH","show_poster__fallback":"ShowPoster_show_poster__fallback__nTlXg"};